import api from '@/service/api';
import variables from "@/service/variables";
export default class FlowService {
     
    //ApplyHeader
    GetFlowNeedToApproval(){
        return api.get(variables.API_URL +'/api/Flow/GetFlowNeedToApproval')
    }
    GetFlowFinish(){
        return api.get(variables.API_URL +'/api/Flow/GetFlowFinish')
    }
    GetFlowProcessing(){
        return api.get(variables.API_URL +'/api/Flow/GetFlowProcessing')
    }
    

    GetFlowNeedToApprovalCount(){
        return api.get(variables.API_URL +'/api/Flow/GetFlowNeedToApprovalCount')
    }
    GetFlow(id){
        return api.get(variables.API_URL +'/api/Flow/GetFlow/' + id)
    }
    Approval(data){
        return api.post(variables.API_URL +'/api/Flow/Approval',data)
    }
    Reject(id,currentStep,reason){
        return api.post(variables.API_URL +'/api/Flow/Reject/'+ id+'/'+currentStep+'/'+reason)
    } 

    GetApplyDataCount(email,newEmail){
        return api.post(variables.API_URL +'/api/Flow/GetApplyDataCount/'+email+'/'+newEmail)
    }
}
    